/**
 * QR de seguimiento en ticket térmico — mostrador / para llevar / comer acá sin mesa.
 * Salón con mesa: el comensal ya está en el local; no imprimir QR de “seguí tu pedido”.
 */
export function shouldIncludePickupTrackingOnReceipt(args: {
  diningTableId?: string | null;
  diningTableName?: string | null;
}): boolean {
  return !(args.diningTableId?.trim() || args.diningTableName?.trim());
}
